const flowers = [
  { kanji: "薔薇", yomi: "ばら" },
  { kanji: "躑躅", yomi: "つつじ" },
  { kanji: "薊", yomi: "あざみ" },
  { kanji: "蒲公英", yomi: "たんぽぽ" },
  { kanji: "蘭", yomi: "らん" },
  { kanji: "菫", yomi: "すみれ" },
  { kanji: "鬱金香", yomi: "うっこんこう" },
  { kanji: "紫陽花", yomi: "あじさい" },
  { kanji: "菖蒲", yomi: "あやめ" },
  { kanji: "花梨", yomi: "かりん" },
  { kanji: "酸漿", yomi: "ほおずき" },
  { kanji: "百合", yomi: "ゆり" },
  { kanji: "秋桜", yomi: "こすもす" },
  { kanji: "桔梗", yomi: "ききょう" },
  { kanji: "百日紅", yomi: "さるすべり" },
  { kanji: "水芭蕉", yomi: "みずばしょう" },
  { kanji: "椿", yomi: "つばき" },
  { kanji: "萩", yomi: "はぎ" },
  { kanji: "向日葵", yomi: "ひまわり" },
  { kanji: "撫子", yomi: "なでしこ" },
  { kanji: "馬酔木", yomi: "あせび" },
  { kanji: "虎杖", yomi: "いたどり" },
  { kanji: "桐", yomi: "きり" },
  { kanji: "水仙", yomi: "すいせん" },
  { kanji: "石楠花", yomi: "しゃくなげ" },
  { kanji: "杜鵑花", yomi: "さつき" },
  { kanji: "敦盛草", yomi: "あつもりそう" },
  { kanji: "梓", yomi: "あずさ" },
  { kanji: "紫羅欄花", yomi: "あらせいとう" },
  { kanji: "槐", yomi: "えんじゅ" },
  { kanji: "朮", yomi: "おけら" },
  { kanji: "雛罌粟", yomi: "ひなげし" },
  { kanji: "彼岸花", yomi: "ひがんばな" },
  { kanji: "木槿", yomi: "むくげ" },
  { kanji: "燕子花", yomi: "かきつばた" },
  { kanji: "亜麻", yomi: "あま" },
];

export { flowers };
